import React from 'react'

import anchorCardStyle from '../../styles/components/anchorsPage/anchor_card'
import SocialLinks from '../SocialLinks'

const AnchorCard = ({ anchor }) => {
  const { avatar = '', name = '', title = '', bio = '' } = anchor

  return (
    <div className='anchor-card' data-testid='anchor-card'>
      <img className='thumbnail' src={avatar} alt={`Anchor ${name} portrait`} />
      <p className='name'>{name}</p>
      <p className='title'>{title}</p>
      <SocialLinks entity={anchor} />
      <p className='bio'>{bio}</p>
      <style jsx>{anchorCardStyle}</style>
    </div>
  )
}

export default AnchorCard
